import React, { Fragment,useEffect } from "react";
import Header from "../components/header";
import PageTitle from "../components/pagetitle";
import ProjectSingle9 from "../components/projectsingle9";
import Testimonial from "../components/testimonial";
import Footer from "../components/footer";

const ProjectPage = () => {
useEffect(()=>{
    window.scrollTo(0,0)    
  })
  return (
    <Fragment>
      <Header />
      <PageTitle pageTitle={"ratnadeep"} pagesub={"Project Details"} />
      <ProjectSingle9 />
      <Testimonial />
      <Footer />
    </Fragment>
  );
};
export default ProjectPage;
